import { AccredibleReadMoreComponent } from '@accredible-frontend-v2/new-components/ui-common';
import { AccredibleResponsiveBreakpoint } from '@accredible-frontend-v2/utils/responsive-helper';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  selector: 'dod-side-content',
  templateUrl: `./side-content.component.html`,
  styleUrls: ['./side-content.component.scss'],
  imports: [TranslocoModule, AccredibleReadMoreComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:resize)': 'onResize()',
  },
})
export class SideContentComponent {
  windowWidth = signal(window.innerWidth);

  isTablet = computed(
    () =>
      this.windowWidth() >= AccredibleResponsiveBreakpoint.SM &&
      this.windowWidth() < AccredibleResponsiveBreakpoint.MD,
  );

  onResize(): void {
    this.windowWidth.set(window.innerWidth);
  }
}
